
$(document).ready(function() {
  var counted = 0;
  $(window).scroll(function() {
    var oTop = $('#counter').offset().top - window.innerHeight ;
  
    if ( $(window).scrollTop() < oTop) {
     counted = 0;
    }
    if (counted == 0 && $(window).scrollTop() > oTop) {
  
      $('.count').each(function() {
        var $this = $(this),
            countTo = $this.attr('data-count');
        $({
          countNum: $this.text()
        }).animate({
          countNum: countTo
        },
		{
          duration: 500,
          easing: 'swing',
          step: function() {
            $this.text(commaSeparateNumber(Math.floor(this.countNum)));
          },
          complete: function() {
            $this.text(commaSeparateNumber(this.countNum));

          }

        });
      });
     
      counted = 1;
    }else{
      
    }

  });
  
   function commaSeparateNumber(val){
    while (/(\d+)(\d{3})/.test(val.toString())){
      val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    }
    return val;
  }
});
